import { render } from "./login-form.vue?vue&type=template&id=5fbae2b0&scoped=true"
import script from "./login-form.vue?vue&type=script&lang=js"
export * from "./login-form.vue?vue&type=script&lang=js"

import "./login-form.vue?vue&type=style&index=0&id=5fbae2b0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fbae2b0"]])

export default __exports__